var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, BLACK_900, Button, GridCol, GridRow, GREEN_600, StateConfigContext, Typography, getTestId, useBreakpoint } from '@airtel/air-design-system';
import { useContext } from 'react';
import { View } from 'react-native';
import { getPriceDetailWidgetStyles } from './PriceDetailWidgetStyles';
export var PriceDetailWidgetComponent = props => {
  var id = props.id,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'PriceDetailWidget' : _props$testID,
    price = props.price,
    pricePostfix = props.pricePostfix,
    strikedPricePostfix = props.strikedPricePostfix,
    oldPrice = props.oldPrice,
    strikedOldPricePostfix = props.strikedOldPricePostfix,
    savePrice = props.savePrice,
    priceAccessibilityProps = props.priceAccessibilityProps,
    style = props.style,
    title = props.title,
    onUserAction = props.onUserAction,
    onPress = props.onPress,
    restProps = __rest(props, ["id", "testID", "price", "pricePostfix", "strikedPricePostfix", "oldPrice", "strikedOldPricePostfix", "savePrice", "priceAccessibilityProps", "style", "title", "onUserAction", "onPress"]);
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var priceDetailWidgetStyles = getPriceDetailWidgetStyles(isLargeScreen);
  var showButton = (title === null || title === void 0 ? void 0 : title.length) > 0;
  var onPressCta = event => {
    if (typeof onPress == 'function') {
      onPress === null || onPress === void 0 ? void 0 : onPress(event);
    }
    onPress && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onPress), Object.assign({}, props)));
  };
  return _jsxs(View, Object.assign({
    style: [priceDetailWidgetStyles.priceBreakupContainer, style]
  }, getTestId(testID), {
    children: [!!(price || strikedPricePostfix || pricePostfix) && _jsx(Typography, Object.assign({}, getTestId(testID, 'price'), {
      color: BLACK_700,
      type: "body-single-line-" + (isLargeScreen ? 'sm' : 'xs'),
      multiText: [{
        text: price,
        color: BLACK_900,
        type: "body-single-line-" + (isLargeScreen ? 'xl' : 'lg') + "-bold",
        style: priceDetailWidgetStyles.textSpacer
      }, {
        text: strikedPricePostfix,
        isStriked: true,
        style: priceDetailWidgetStyles.textSpacer
      }, {
        text: pricePostfix,
        style: priceDetailWidgetStyles.textSpacer
      }]
    }, priceAccessibilityProps)), _jsxs(GridRow, Object.assign({
      noMargin: true,
      style: priceDetailWidgetStyles.gridRowStyle
    }, {
      children: [_jsx(GridCol, Object.assign({
        noGutter: true,
        breakpoints: {
          lg: 6
        }
      }, {
        children: !!(oldPrice || strikedOldPricePostfix || savePrice) && _jsx(Typography, {
          color: BLACK_700,
          type: "body-para-" + (isLargeScreen ? 'sm' : 'xs'),
          style: priceDetailWidgetStyles.priceBreakupOldPrice,
          multiText: [{
            text: oldPrice,
            style: priceDetailWidgetStyles.textSpacer
          }, {
            text: strikedOldPricePostfix,
            isStriked: true,
            style: priceDetailWidgetStyles.textSpacer
          }, {
            text: savePrice,
            color: GREEN_600,
            isBold: true,
            style: priceDetailWidgetStyles.textSpacer
          }]
        })
      })), _jsx(GridCol, Object.assign({
        noGutter: true,
        breakpoints: {
          lg: 6
        },
        style: priceDetailWidgetStyles.gridColStyle
      }, {
        children: showButton && _jsx(Button, Object.assign({}, restProps, {
          title: title,
          onPress: onPressCta,
          theme: theme
        }, getTestId(testID + "_button")))
      }))]
    }))]
  }));
};
PriceDetailWidgetComponent.genericRendererKey = 'AirPriceDetailWidget';